export default "__VITE_ASSET__C8ON9bz2__"